<rappider-modal title="Edit Grid Config"
                [(visible)]="isEditModalVisible"
                okText="Save"
                cancelText="Cancel"
                [fullScreen]="true"
                [autoClose]="modalAutoClose"
                [bodyStyle]="{ padding: '0.5rem 2.5rem 0rem 1.5rem' }"
                (okClick)="onGridConfigSave()"
                (cancelClick)="onCancel()"
                (afterModalOpen)="onGridModalAfterOpen()">
  <div class="container-fluid content-area grid-builder-container"
       style="height: 100%;">

    <as-split direction="horizontal"
              [gutterSize]="10">
      <as-split-area [size]="22"
                     [minSize]="20"
                     [maxSize]="40">
        <div class="section-container">
          <div class="section-header">
            <div class="grid-builder-header">
              <h6> Table Columns </h6>
              <rappider-button text="Add Column"
                               [icon]="{name: 'fa-solid fa-plus'}"
                               (click)="onAddColumnClick()"></rappider-button>
            </div>
            <hr>
          </div>
          <div class="section-content">
            <rappider-grid-builder-columns [(ngModel)]="tempValue.columns"
                                           (ngModelChange)="onColumnsChange()"
                                           (populatedDataChange)="onPopulatedDataChange($event)"
                                           (editColumnRequest)="onEditColumnRequest($event)"
                                           (columnDeleted)="onColumnDeleted()"
                                           [resetSelection]="columnToEdit === null"></rappider-grid-builder-columns>
          </div>
        </div>
      </as-split-area>
      <as-split-area [size]="46"
                     [minSize]="30"
                     [maxSize]="65">
        <div class="section-container">
          <div class="section-header">
            <div class="grid-builder-header">
              <h6> Table Preview </h6>
            </div>
            <hr>
          </div>
          <div class="section-content table-preview-content">
            <rappider-list-grid [data]="populatedData"
                                [config]="tempValue"></rappider-list-grid>

            <!-- Validation Alert -->
            <div class="grid-builder-validation-alert">
              <rappider-alert *ngIf="validationAlertVisible"
                              [type]="validationAlertConfig.type"
                              [title]="validationAlertConfig.title"
                              [description]="validationAlertConfig.description"
                              [closeable]="validationAlertConfig.closeable"
                              [showIcon]="validationAlertConfig.showIcon"
                              class="grid-validation-alert"></rappider-alert>
            </div>

          </div>
        </div>
      </as-split-area>
      <as-split-area [size]="32"
                     [minSize]="25"
                     [maxSize]="40">
        <div class="section-container">
          <div class="section-content settings-content">
            <rappider-grid-builder-settings [ngModel]="tempValue"
                                            (ngModelChange)="onItemsChange($event)"
                                            [columnToEdit]="columnToEdit"
                                            (columnSaved)="onColumnSaved($event)"
                                            (editJsonData)="openJsonEditorModal()"></rappider-grid-builder-settings>
          </div>
        </div>
      </as-split-area>
    </as-split>
  </div>
</rappider-modal>

<rappider-button text="Edit Grid Data"
                 (click)="openEditModal()"></rappider-button>

<rappider-json-editor-modal [data]="tempValue"
                            [title]="'Edit Grid Data'"
                            [visible]="isJsonEditorModalVisible"
                            (visibleChange)="onJsonEditorVisibleChange($event)"
                            (dataChange)="onDataChange($event)"></rappider-json-editor-modal>
